module.exports = __webpack_public_path__ + "media/application/images/2018/star-grey-da7f4044830bf7052da838d921481b31.svg";